import { FC } from 'react';
import { SpaceFileMimeType } from 'shared';

import { FileIconVariant } from '../../../../assets/icons/file-icon';
import { FileTypeIconKind } from '../../../../assets/icons/file-type-icon';
import { FileIcon, FileTypeIcon } from '../../../../assets/icons/index';

const FILE_TYPE_BY_MIME: Record<string, FileTypeIconKind> = {
  [SpaceFileMimeType.CSV]: FileTypeIconKind.CSV,
  [SpaceFileMimeType.DOC]: FileTypeIconKind.DOC,
  [SpaceFileMimeType.DOCX]: FileTypeIconKind.DOCX,
  [SpaceFileMimeType.JPEG]: FileTypeIconKind.JPG,
  [SpaceFileMimeType.PDF]: FileTypeIconKind.PDF,
  [SpaceFileMimeType.PLAIN_TEXT]: FileTypeIconKind.TXT,
  [SpaceFileMimeType.PNG]: FileTypeIconKind.PNG,
  [SpaceFileMimeType.PPT]: FileTypeIconKind.PPT,
  [SpaceFileMimeType.PPTX]: FileTypeIconKind.PPT,
  [SpaceFileMimeType.XLS]: FileTypeIconKind.XLS,
  [SpaceFileMimeType.XLSX]: FileTypeIconKind.XLS,
};

// Activity rows carry a file's name and not its type, so there the extension decides.
const FILE_TYPE_BY_EXTENSION: Record<string, FileTypeIconKind> = {
  csv: FileTypeIconKind.CSV,
  doc: FileTypeIconKind.DOC,
  docx: FileTypeIconKind.DOCX,
  jpeg: FileTypeIconKind.JPG,
  jpg: FileTypeIconKind.JPG,
  pdf: FileTypeIconKind.PDF,
  png: FileTypeIconKind.PNG,
  ppt: FileTypeIconKind.PPT,
  pptx: FileTypeIconKind.PPT,
  svg: FileTypeIconKind.SVG,
  txt: FileTypeIconKind.TXT,
  xls: FileTypeIconKind.XLS,
  xlsx: FileTypeIconKind.XLS,
  zip: FileTypeIconKind.ZIP,
};

type BrowserFileIconProps = {
  /** Default 16, the browser's own size. */
  size?: number;
} & ({ contentType: string; fileName?: never } | { contentType?: never; fileName: string });

export const BrowserFileIcon: FC<BrowserFileIconProps> = ({ contentType, fileName, size = 16 }) => {
  const kind = contentType
    ? FILE_TYPE_BY_MIME[contentType]
    : FILE_TYPE_BY_EXTENSION[fileName?.split('.').pop()?.toLowerCase() ?? ''];

  if (!kind) {
    return (
      <FileIcon height={size} iconColor="#344054" variant={FileIconVariant.DEFAULT} width={size} />
    );
  }

  return <FileTypeIcon height={size} kind={kind} width={size} />;
};
